import utils from '../utils';

function init() {
	var mailchimpForm = document.querySelector('#mailchimp-form');
    
	if (mailchimpForm) {
		var responseContainer = mailchimpForm.querySelector('.response-message'),
			button = mailchimpForm.querySelector('button');

            mailchimpForm.addEventListener('submit', function (e) {

			e.preventDefault();
			var email = mailchimpForm.querySelector('input[type="email"]').value,
				fname = mailchimpForm.querySelector('[name="FNAME"]').value,
				lname = mailchimpForm.querySelector('[name="LNAME"]').value,
				company = mailchimpForm.querySelector('[name="COMPANY"]').value,
				country = mailchimpForm.querySelector('[name="COUNTRY"]').value,
				province = mailchimpForm.querySelector('[name="PROVINCETW"]').value,
				action = window.baseUrl + '/mailchimp/mailchimp-register.php',
				params = 'EMAIL=' + email + '&FNAME=' + fname + '&LNAME=' + lname + '&COMPANY=' + company + '&COUNTRY=' + country + '&PROVINCETW=' + province,
				color = '#0F9D58', //green
				message;

			/* if (!mailchimp.querySelector('input[name="acceptance-newsletter"]').checked) {
				return;
			} */

			utils.ajaxLoad(action, 'POST', 'application/x-www-form-urlencoded; charset=UTF-8', 'text', params, function (result) {
				var response = JSON.parse(result);

				if (response.status === 'subscribed') {
					message = 'Successo! Grazie per esseri iscritto alla nostra newsletter.';
				} else {
					if (response.status === 400) {
						message = email + ' è già iscritto alla newsletter.';
					} else {
						message = 'Si è verificato un errore, riprova più tardi.';
						color = '#DB4437'; //red
					}
				}

				button.classList.remove('is-loading');
				responseContainer.innerHTML = message;
				responseContainer.style.color = color;
				responseContainer.setAttribute('aria-hidden', 'false');

			});
		});
	}
}

export default {
	init,
};